import Vue from 'vue'
import { Store } from 'vuex'
import Component from 'vue-class-component'
import RootState from '../../store/state'
import isBrowserIE from '../../misc/is-browser-ie'
import { Watch } from 'vue-property-decorator'

@Component({
  props: {
    duration: {
      type: Number,
      required: true
    },
    running: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
export default class TimerVue extends Vue {
  $store: Store<RootState>
  readonly duration: number
  readonly running: boolean
  isActive: boolean = false
  timer: any = -1

  get isIE(): boolean {
    return isBrowserIE()
  }

  mounted(): void {
    if (this.running) {
      this.start()
    }
  }

  beforeDestroy(): void {
    clearTimeout(this.timer)
  }

  @Watch('running')
  start(): void {
    if (this.running) {
      this.startTimer()
      return
    }
    this.stop()
  }

  startTimer(): void {
    if (this.isActive) {
      return
    }
    this.isActive = true
    this.timer = setTimeout(() => {
      this.notifyTimeout()
    }, this.duration)
    if (this.isIE) {
      this.animate()
    }
  }

  animate(): void {
    const start = performance.now()
    const doAnimate = (now: number) => {
      const passed = now - start
      const restRate = (Math.max(this.duration - passed, 0) / this.duration) * 100
      this.$el.style.strokeDasharray = `${restRate} 100`
      if (restRate !== 0) {
        requestAnimationFrame(doAnimate)
      }
      if (!this.isActive) {
        this.$el.style.strokeDasharray = null
      }
    }
    requestAnimationFrame(doAnimate)
  }

  stop(): void {
    clearTimeout(this.timer)
    this.isActive = false
    this.$el.classList.remove('message__timer--start')
    this.$el.style.strokeDasharray = null
  }

  notifyTimeout(): void {
    this.$emit('timeout')
  }
}
